import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import './HelpCategoryPage.css';

/**
 * Create your first group Article Page
 */
const CreateGroup = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Create your first group</h1>
                <p className="article-subtitle">
                  Learn how to set up a shared space to track expenses, settle debts, and manage a shared wallet with your friends.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Overview</h2>
                  <p className="article-section-intro">
                    Groups are the heart of WeSplit. Whether you are planning a holiday, sharing an apartment, or managing a project, creating a group allows you to pool funds and track who owes what in real-time.
                  </p>
                </div>
              </section>


              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Step-by-Step Guide</h2>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Initiate Creation:</strong> From the main dashboard, tap on the + (Plus) button to start a new action.
                    </li>
                    <li>
                      <strong>Select Group Type:</strong> Choose the option 'Create shared wallet'. This sets up a dedicated space where transactions and balances are tracked specifically for this group.
                    </li>
                    <li>
                      <strong>Name Your Group:</strong> Give your group a clear name (e.g., 'Summer Trip,' 'Roommates,' 'Friday Dinner'). This helps you identify it easily on your dashboard.
                    </li>
                    <li>
                      <strong>Add Participants:</strong> Select friends to add to the group. You can search for existing WeSplit users or invite new ones to join the shared wallet.
                    </li>
                  </ol>
                </div>
              </section>


              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Good to Know</h2>
                </div>

                <div className="article-subsection">
                  <ul className="article-list-dots">
                    <li>
                      <strong>Customize Later:</strong> Don't worry if you don't have all the details right away. You can update the group name, add a group photo, or invite more participants at any time via the group settings.
                    </li>
                    <li>
                      <strong>Shared Wallet:</strong> By creating a 'shared wallet' group, you enable streamlined settlements using the app's integrated crypto features.
                    </li>
                  </ul>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Top up your account',
                  route: getHelpRoute(getHelpArticleRoute('getting-started', 'top-up-account'))
                }}
                next={{
                  title: 'Manage your group',
                  route: getHelpRoute(getHelpArticleRoute('getting-started', 'manage-group'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default CreateGroup;
